import React from 'react';
import s from './Footer.module.scss';
import { useIntl } from 'gatsby-plugin-intl';
import { SocialMedia } from '@components/social-media/SocialMedia.component';
import { FacebookURL, InstagramURL, LinkedInURL, YoutubeURL } from '@helpers/socials.helper';
import { getLink } from '@helpers/linking.helper';
import { PageType } from '@constants/pageType.constants';
import { TermsAndConditionsFiles } from '@helpers/termsFiles.helper';

const FooterComponent = () => {
  const intl = useIntl();
  const currentLocale = intl.locale;

  return (
    <footer className={s.footer}>
      <div className={s.footer__mobileLogo}>
        <a className={s.footer__link} href={getLink(currentLocale, PageType.START)}>
          <img
            src={'/avionaut.svg'}
            alt={intl.formatMessage({ id: 'footerLogoAltText' })}
          />
        </a>
      </div>
      <div className={s.footer__firstRow}>
        <div className={s.footer__firstRow_company}>
          <p className={s.footer__firstRow_companyText}>
            {intl.formatMessage({ id: 'footer__company_name' })}
          </p>
          <p className={s.footer__firstRow_companyText}>
            {'Szarlejka, ul. Łukaszewicza 172'}
          </p>
          <p className={s.footer__firstRow_companyText}>
            {'42-130 Wręczyca Wielka'}
          </p>
          <p className={s.footer__firstRow_companyText}>
            {intl.formatMessage({ id: 'footer__company_country' })}
          </p>
          <p className={s.footer__firstRow_companyText}>
            {intl.formatMessage({ id: 'footer__company_nip' })}
          </p>
          <p className={s.footer__firstRow_companyText}>
            {intl.formatMessage({ id: 'footer__company_regon' })}
          </p>
          <p className={s.footer__firstRow_companyDescription}>
            {intl.formatMessage({ id: 'footer__company_description' })}
          </p>
        </div>
        <div className={s.footer__firstRow_infoLinks}>
          <div>
            <p className={s.footer__firstRow_infoHeader}> {intl.formatMessage({ id: 'footer__categories' })}</p>
            <ul className={s.footer__firstRow_infoList}>
              <a className={s.footer__link} href={getLink(currentLocale, PageType.CAR_SEATS)}>
                <li className={s.footer__firstRow_infoText}>{intl.formatMessage({ id: 'navbar__carSeats' })}</li>
              </a>
              <a className={s.footer__link} href={getLink(currentLocale, PageType.CAR_SEATS)}>
                <li className={s.footer__firstRow_infoText}>{intl.formatMessage({ id: 'hpProducts__strollers_title' })}</li>
              </a>
            </ul>
          </div>
          <div>
            <p className={s.footer__firstRow_infoHeader}> {intl.formatMessage({ id: 'footer__info' })}</p>
            <ul className={s.footer__firstRow_infoList}>
              <a className={s.footer__link} href={getLink(currentLocale, PageType.SHOPS)}>
                <li className={s.footer__firstRow_infoText}>{intl.formatMessage({ id: 'footer__info_shops' })}</li>
              </a>
              <a className={s.footer__link} href={getLink(currentLocale, PageType.WARRANTY)}>
                <li className={s.footer__firstRow_infoText}>{intl.formatMessage({ id: 'footer__warranty' })}</li>
              </a>
              <a href={`/${TermsAndConditionsFiles[currentLocale]}.pdf`} target={'_blank'} className={s.footer__link}
                 rel="noopener noreferrer">
                <li
                  className={s.footer__firstRow_infoText}>{intl.formatMessage({ id: 'home__uspSectionTopRightHeader' })}</li>
              </a>
              <a className={s.footer__link} href={getLink(currentLocale, PageType.KNOWLEDGE_BASE)}>
                <li className={s.footer__firstRow_infoText}>{intl.formatMessage({ id: 'navbar__knowledgeBase' })}</li>
              </a>
            </ul>
          </div>
          <div>
            <p className={s.footer__firstRow_infoHeader}> {intl.formatMessage({ id: 'footer__support' })}</p>
            <ul className={s.footer__firstRow_infoList}>
              <a href={getLink(currentLocale, PageType.CONTACT)} className={s.footer__link}>
                <li className={s.footer__firstRow_infoText}>{intl.formatMessage({ id: 'metaTitle__contact' })}</li>
              </a>
              <a href={getLink(currentLocale, PageType.RODO)} className={s.footer__link}
                 rel="noopener noreferrer nofollow">
                <li className={s.footer__firstRow_infoText}>{intl.formatMessage({ id: 'metaTitle__rodo' })}</li>
              </a>
            </ul>
          </div>
        </div>
      </div>
      <div className={s.footer__secondRow}>
        <div className={s.footer__logoDesktop}>
          <a className={s.footer__link} href={getLink(currentLocale, PageType.START)}>
            <img
              src={'/avionaut.svg'}
              alt={intl.formatMessage({ id: 'footerLogoAltText' })}
            />
          </a>
        </div>
        <div className={s.footer__secondRow_content}>
          <div className={s.footer__social}>
            <SocialMedia facebookURL={FacebookURL[currentLocale]} instagramURL={InstagramURL[currentLocale]}
                         linkedInURL={LinkedInURL[currentLocale]} youtubeURL={YoutubeURL[currentLocale]}/>
          </div>
          <div className={s.footer__copyright}>
            {`Copyright © ${new Date().getFullYear()} | All Rights Reserved.`}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterComponent;
